
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security-policy",
      function () {
        return require("private-next-pages/security-policy/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security-policy"])
      });
    }
  